import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { SigningService } from 'src/app/services/signing.service';

@Component({
    selector: 'document-esigning-request-confirmation',
    templateUrl: './document-esigning-request-confirmation-component.html',
    styleUrls: ['./document-esigning-request-confirmation-component.scss'],
    standalone: false
})
export class DocumentESigningRequestConfirmationComponent implements OnInit {

  constructor(private readonly _signingService: SigningService,
    private readonly _notifyService: NotificationService) { }

  ngOnInit(): void {
    this.sendConfirmation();
  }

  sendConfirmation = () => {
    const searchParams = new URLSearchParams(location.search);
    const action = searchParams.get('event') ?? searchParams.get('esign.status');
    const loanDocTaskId = searchParams.get('loanDocTaskId');

    const vendorQueryParameters = Array.from(searchParams.entries()).map(([key, value]) => ({ key, value }));

    let urlParams = `?action=${encodeURIComponent(action ?? '')}&loanDocTaskId=${encodeURIComponent(loanDocTaskId ?? '')}`;

    this._signingService.OnSignerViewSubmitted(urlParams, vendorQueryParameters).subscribe({
      next: (response) => {
        window.parent.postMessage({
          shouldCloseEsignDocIframe: true,
          response: response
        }, '*');
      },
      error: (err) => {
        this._notifyService.showError(err ? err.message || err : "Send eSigning Document for Signing", "Error");
      }
    });
  }

}
